import { ConversationTag } from '../../home/v1/typings';

export enum WAGroupJoinApprovalMode {
  APPROVAL_REQUIRED = 'approval_required',
  AUTO_APPROVE = 'auto_approve',
}

export interface CreateWAGroupPayload {
  integrationId: string;
  subject: string;
  description?: string;
  joinApprovalMode?: WAGroupJoinApprovalMode;
}

export interface CreateWAGroupResponse {
  groupId: string;
  wabaNumber: string;
}

export enum WAGroupStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  DELETED = 'DELETED',
}

export interface WAGroupChatMeta {
  groupId: string;
  groupChatName: string;
  groupChatDescription: string | null;
  clientCustomGroupId?: string | null;
  groupChatId: string;
  memberCount: number;
  integrationDisplayName: string;
  integrationId: string;
  integrationWabaNumber: string;
  assignedUserId: string | null;
  assignedUserName?: string | null;
  createdBy: {
    id: string;
    name: string;
  };
  waGroupStatus?: WAGroupStatus;
  dateCreated: string;
  inviteLink?: string;
  status?: WAGroupStatus;
  tags?: ConversationTag[];
  wabaProfilePictureUrl?: string | null;
  scheduledChatMessagesCount?: number;
}

export enum WAGroupEventTypes {
  GROUP_INVITE_LINK_READY = 'group_invite_link_ready',
  GROUP_PARTICIPANT_COUNT_UPDATED = 'group_participant_count_updated',
}

export interface WAGroupInviteLinkReadyPayload {
  event: WAGroupEventTypes.GROUP_INVITE_LINK_READY;
  groupChatId: string;
  inviteLink: string;
}

export interface WAGroupParticipantCountUpdatedPayload {
  event: WAGroupEventTypes.GROUP_PARTICIPANT_COUNT_UPDATED;
  groupChatId: string;
  participantCount: number;
}

export type WAGroupPayload = WAGroupInviteLinkReadyPayload | WAGroupParticipantCountUpdatedPayload;

export interface WAGroupMember {
  id: string;
  groupId: string;
  customerId: string | null;
  dateCreated: string;
  dateUpdated: string;
  wabaNumber: string | null;
  wabaName: string | null;
  name: string | null;
  phoneNumber: string | null;
  imageUrl?: string;
  isAdmin: boolean;
  isLeft: boolean;
  isRemoved: boolean;
}

export interface WAGroupMembersResponse {
  participants: WAGroupMember[];
  hasMore: boolean;
  lastParticipantId: string | null;
  olderThanTimestamp: string | null;
}

export type WAGroupMembersPaginationData = Omit<WAGroupMembersResponse, 'participants'>;

export type WAGroupMetaDataResponse = {
  currentGroupsCount: number;
  groupsLimit: number;
};
